import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import { ObjectEdit } from "../../../../_metronic/layout/components/basePage/pages/object-edit/ObjectEdit";
import ObjectsPage from "../../../../_metronic/layout/components/basePage/pages/ObjectsPage";
import { FilterObjectsUIProvider } from "../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext";
import {
  rowFormatter,
  formFields,
  otherFields,
  initObject,
  ObjectEditSchema,
  columns,
  detailColumns,
  provienceColumns,
  prepareFilter,
  provienceFilterFields,
  filterInitialValues,
  setParentData,
  setDetailData,
} from "./ManagementAuditFormReportUtils";

const ManagementProvienceAuditFormReportPage = () => {
  const { currentState } = useSelector(
    (state) => ({ currentState: state.provienceAuditFormReports }),
    shallowEqual
  );

  let isFullAccess = false;
  const { menuList } = useSelector(
    (state) => ({ menuList: state.auth.menu }),
    shallowEqual
  );

  if (menuList.find((q) => q.url == "/manageReportProvience")) {
    const temp = menuList.find((q) => q.url == "/manageReportProvience");
    isFullAccess = temp.isFullAccess;
  }

  return (
    <FilterObjectsUIProvider initialFilter={filterInitialValues}>
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>
          <ContentRoute
            path="/manageReportProvience"
            render={(props) => (
              <ObjectsPage
                rowFormatter={rowFormatter}
                filterByShowButton={true}
                AuditAction={false}
                haveGeneralAction={false}
                isFullAccess={isFullAccess}
                basePath="/manageReportProvience"
                api="api/AuditFormResult"
                getFunctionName="GetProviencesFormResultReport"
                currentState={currentState}
                columns={columns}
                detailColumns={detailColumns}
                setParentData={setParentData}
                setDetailData={setDetailData}
                prepareFilter={prepareFilter}
                filterFields={provienceFilterFields}
                filterInitialValues={filterInitialValues}
                enablePagination={false}
                haveExportButton={true}
                exportfuncName="GetExcelProviencesFormResultReport2"

                haveStimulsoftReport={true}
                mrtUrl="/reports/ProvienceFormResultReports.mrt"
                jsonFileName="GetFormResultReport"
              />
            )}
          />
        </Switch>
      </Suspense>
    </FilterObjectsUIProvider>
  );
};

export default ManagementProvienceAuditFormReportPage;
